import axios from 'axios';

export const BASE_URL = 'https://padel-if-production.up.railway.app/api/v1';
// export const BASE_URL = 'http://localhost:3000/api/v1'

export const http = axios.create({
  baseURL: BASE_URL
});
